import React from 'react';
import ContainerEcommerce from '../../../Componant/DashBoard/Ecommerce/ContainerEcommerce';

const Ecommerce = () => {
  return (
    <div className='page-body'>
      <ContainerEcommerce />
    </div>
  );
};

export default Ecommerce;
